<script setup lang="ts">
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { VerifiedMarker } from '@/components/ui/verified-marker'

defineProps<{
  avatar_url: string | null,
  display_name?: string | null,
  verified?: boolean,
}>()
</script>

<template>
  <div class="flex items-center">
    <Avatar class="w-8 h-8">
      <AvatarImage v-if="avatar_url" :src="avatar_url" :alt="display_name" />
      <AvatarFallback></AvatarFallback>
    </Avatar>
    <div class="ml-3 flex items-center gap-1" v-if="display_name">
      {{ display_name }}
      <VerifiedMarker v-if="verified" />
    </div>
  </div>
</template>
